var map = {
	"../components/coursedetails/coursedetails.module": [
		"./src/app/components/coursedetails/coursedetails.module.ts",
		"common",
		"components-coursedetails-coursedetails-module"
	],
	"../components/courses/courses.module": [
		"./src/app/components/courses/courses.module.ts",
		"common",
		"components-courses-courses-module"
	],
	"../components/editprofile/editprofile.module": [
		"./src/app/components/editprofile/editprofile.module.ts",
		"components-editprofile-editprofile-module"
	],
	"../components/features/features.module": [
		"./src/app/components/features/features.module.ts",
		"common",
		"components-features-features-module"
	],
	"../components/home/home.module": [
		"./src/app/components/home/home.module.ts",
		"common",
		"components-home-home-module"
	],
	"../components/login/login.module": [
		"./src/app/components/login/login.module.ts",
		"components-login-login-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;